export const PATH_NAME = {
  HOME: '/',
  HISTORY: '/history',
  WAIT_LIST: '/waitlist',
  SWAP: '/swap',
  FAUCET: '/faucet',
  TRADE_DETAIL: ':tradeId',
  TRANSACTION_DETAIL: '/trade/:tradeId',
  SHARE: '/share',
  INVITE_FRIENDS: '/invite-friends',
  REFERRAL_NETWORK: '/referral-network',
  FIXED_SWAP: '/fixed-swap',
  FIXED_SWAP_DEPOSIT: '/fixed-swap/deposit',
  FIXED_SWAP_DEPOSIT_DETAIL: '/fixed-swap/deposit',
  FIXED_SWAP_VAULT: '/fixed-swap/vault',
  FIXED_SWAP_DEPOSIT_HISTORY: '/fixed-swap/deposit-history',
  REFERRAL_HUB: '/join',
  CLAIM_HISTORY: '/claim-history',
}

export const PUBLIC_PAGES = [PATH_NAME.WAIT_LIST]
